import * as analysisState from '@/components/Analysis/state';
import { point3dToNumber3 } from '@/utils/pointOfInterest';
import { HtmlMarkerInstanceProps, HtmlMarkerSetProps, Number3 } from '@fabric-web/3d-viewer';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { AbyssIcon } from '../../../../../assets/icons/AbyssIcon';
import * as poiState from '../state';
import { useRouter } from '@/hooks';

const DISTANCE_THRESHOLD = 250;
const MAX_MARKERS_TO_SHOW = 1000;

export const usePointOfInterestPointer = () => {
  const selectedPoiId = useAtomValue(poiState.selectedPointOfInterestId);
  const showPointOfInterestPointer = useAtomValue(analysisState.showPointOfInterestPointer);
  const newPointOfInterestCenterPoint3d = useAtomValue(poiState.newPointOfInterestCenterPoint3d);
  const selectedPointOfInterest = useAtomValue(poiState.selectedPointOfInterest);
  const router = useRouter();

  const isAtScreenshotPage = router.pathname.includes('screenshot');

  const centerPoint3d = useMemo(() => {
    if (isAtScreenshotPage) {
      return selectedPointOfInterest?.centerPoint3d;
    }
    return newPointOfInterestCenterPoint3d;
  }, [isAtScreenshotPage, newPointOfInterestCenterPoint3d, selectedPointOfInterest]);

  const poiPointerSet: HtmlMarkerSetProps[] = useMemo(() => {
    const instances: HtmlMarkerInstanceProps[] = [];
    if (!showPointOfInterestPointer || !selectedPoiId) return [];

    instances.push({
      id: `html-marker-${selectedPoiId}-pointer`,
      position: point3dToNumber3(centerPoint3d, -0.005) as Number3,
      children: <AbyssIcon iconName="viewer-pointer" />,
      distanceThreshold: DISTANCE_THRESHOLD,
      scale: 0.2,
      divStyle: {
        pointerEvents: 'none',
        backgroundColor: 'transparent',
      },
      markerHeight: 0,
    });

    const markerSet: HtmlMarkerSetProps = {
      id: 'html-markerset-1',
      instances: instances.filter((instance) => !!instance.position),
      enableFilteringByVisibilityBox: true,
      maxMarkersToShow: MAX_MARKERS_TO_SHOW,
    };
    return [markerSet];
  }, [centerPoint3d, selectedPoiId, showPointOfInterestPointer]);

  return poiPointerSet;
};
